export const displayDiameterError = (pileDiameter, groutDiameter, data) => {
  if ((data?.pileSegments?.length >= 1) && pileDiameter >= groutDiameter) {
    return "The shaft you have selected is larger than your grout diameter.";
  }
}

export const DISCONTINUED_PILE_WARNING = "This pile type has been discontinued.";
